import api from '../utils/api';

const login = async (email: string, password: string) => {
  return api.post(`/auth/login`, { email, password });
};

const register = async (email: string, password: string) => {
  return api.post(`/auth/register`, { email, password });
};

const forgotPassword = async (email: string) => {
  return api.post(`/user/forgot_password`, { email });
};

const resetPassword = async (token: string, password: string) => {
  return api.post(`/user/reset_password`, { token, password  });
};

export const usersApi = {
  login,
  register,
  forgotPassword,
  resetPassword
};
